module.exports = __webpack_public_path__ + "img/25.26c5a749.jpg";